import { render, staticRenderFns } from "./PlayerOverview.vue?vue&type=template&id=e0cc7a52"
import script from "./PlayerOverview.vue?vue&type=script&lang=js"
export * from "./PlayerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports